(function() {
  'use strict';

  // Search: dynamic-css-rule - converts sanitized template data into one managed style block.
  var STYLE_ID = 'bc-dynamic-css-rules';
  var invalidCssPattern = /[{}<>]/;
  var dynamicCssSelector = '[data-dynamic-css]';
  var dynamicCssAttributes = ['data-css-selector', 'data-css-declarations'];
  var elementNodeType = 1;
  var animationFrameFallbackDelay = 16;
  var requestFrame = window.requestAnimationFrame || function(callback) {
    window.setTimeout(callback, animationFrameFallbackDelay);
  };
  var applyQueued = false;
  var shopifyEditorEvents = [
    'shopify:section:load',
    'shopify:section:unload',
    'shopify:section:select',
    'shopify:section:deselect',
    'shopify:section:reorder',
    'shopify:block:select',
    'shopify:block:deselect'
  ];
  var observerOptions = {
    attributes: true,
    attributeFilter: dynamicCssAttributes,
    childList: true,
    subtree: true
  };

  function cleanDeclarations(declarations) {
    return declarations
      .split(';')
      .map(function(declaration) {
        return declaration.trim();
      })
      .filter(function(declaration) {
        return declaration && declaration.indexOf(':') !== -1 && !invalidCssPattern.test(declaration);
      })
      .join(';');
  }

  function buildRules() {
    var nodes = document.querySelectorAll(dynamicCssSelector);
    var css = [];

    Array.prototype.forEach.call(nodes, function(node) {
      var selector = (node.getAttribute('data-css-selector') || '').trim();
      var declarations = cleanDeclarations(node.getAttribute('data-css-declarations') || '');

      if (!selector || !declarations || invalidCssPattern.test(selector)) {
        return;
      }

      css.push(selector + '{' + declarations + ';}');
    });

    return css.join('\n');
  }

  function applyRules() {
    var css = buildRules();
    var style = document.getElementById(STYLE_ID);

    if (!css) {
      if (style) {
        style.parentNode.removeChild(style);
      }
      return;
    }

    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    if (style.textContent !== css) {
      style.textContent = css;
    }
  }

  function queueApplyRules() {
    if (applyQueued) {
      return;
    }

    applyQueued = true;

    requestFrame(function() {
      applyQueued = false;
      applyRules();
    });
  }

  function containsDynamicCssNode(node) {
    if (!node || node.nodeType !== elementNodeType) {
      return false;
    }

    if (node.matches && node.matches(dynamicCssSelector)) {
      return true;
    }

    return !!(node.querySelector && node.querySelector(dynamicCssSelector));
  }

  function observeDynamicCssRules() {
    if (!window.MutationObserver || !document.documentElement) {
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      var shouldApplyRules = mutations.some(function(mutation) {
        if (mutation.type === 'attributes' && containsDynamicCssNode(mutation.target)) {
          return true;
        }

        return Array.prototype.some.call(mutation.addedNodes, containsDynamicCssNode) ||
          Array.prototype.some.call(mutation.removedNodes, containsDynamicCssNode);
      });

      if (shouldApplyRules) {
        queueApplyRules();
      }
    });

    observer.observe(document.documentElement, observerOptions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRules);
  } else {
    applyRules();
  }

  shopifyEditorEvents.forEach(function(eventName) {
    document.addEventListener(eventName, queueApplyRules);
  });

  observeDynamicCssRules();
}());
